import Vue from 'vue';
import Router from 'vue-router';

// 学生页面路由
import studentRouter from '@/pages/student/router';
// 权限相关路由
import pwoerRouter from '@/pages/power/router';
// 前程日本流程页面路由
import qcrbRouter from '@/pages/qcrb/router';
// 支付、合同管理列表路由
import paymentRouter from '@/pages/payment/router';
// 财务系统路由
import financeRouter from '@/pages/finance/router';
// 通用模块路由
import systemRouter from '@/pages/system/router';
// 日志路由
import logRouter from '@/pages/log/router';
// 计划任务
import plantaskRouter from '@/pages/plantask/router';
// offer路由
import offerRouter from '@/pages/offer/router';
// 通用活动路由
import activityRouter from '@/pages/activity/router';
// 用户行为主题路由
import actionGroupRouter from '@/pages/actionGroup/router';
// 统计报表路由
import reportRouter from '@/pages/report/router';
// 业务看板路由
import biRouter from '@/pages/bi/router';
// 销售工具
import salesToolsRouter from '@/pages/salesTools/router';
// 文案流程路由
import processRouter from '@/pages/process/router.js';
// 日本文案路由
import jpProcessRouter from '@/pages/jpprocess/router.js';
// 更多应用
import toolboxRouter from '@/pages/toolbox/router';
// 用户登记页面
import specialRouter from '@/pages/special/router';
// 分配页面
import taskRouter from '@/pages/task/router';
// 公海管理
import internationalWaters from '@/pages/internationalWaters/router';
// 会员管理
import memberRouter from '@/pages/member/router';
// h5页面
import h5Router from '@/pages/h5/router';
// h5we页面
import h5weRouter from '@/pages/h5we/router';
// 英澳扩展管理页面
import europeRouter from '@/pages/europe/router';
// 特殊页面，无外框
import checkin from '@/pages/special/checkIn';

import globalRouter from './global';

// const Login = () => import('@/components/Login.vue');
const Login = () => import('@/pages/Login.vue');
const dingLogin = () => import('@/pages/dingLogin.vue');
const dingSign = () => import('@/components/dingSign.vue');

Vue.use(Router);

const routes = [
  {
    path: '/', redirect: '/student'
  },
  {
    path: '/special', name: 'specialCheckIn', component: checkin, meta: { noLayout: true },
  },
  {
    path: '/login', name: 'fibLogin', component: Login, meta: { noLayout: true, noAuth: true },
  },
  {
    path: '/dingLogin', name: 'dingLogin', component: dingLogin, meta: { noLayout: true, noAuth: true },
  },
  {
    path: '/dingSign/:teacherId/:crmId', name: 'dingSign', component: dingSign, meta: { noLayout: true, noAuth: true },
  },
  // {
  //   path: '/customer/enter_starmap/:jwt',
  //   name: 'enterStarmap',
  //   component: () => import('@/training/pages/talk/imEnterStarmap.vue'),
  //   meta: {
  //     c: 'customer', a: 'enter_starmap', noLayout: true, noAuth: true
  //   }
  // },
];

// const base = process.env.NODE_ENV === 'development'
//   ? '/frontend/'
//   : (localConfig.routerBase.replace(/"/g, '') || '/');

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.addRoutes(studentRouter);
router.addRoutes(pwoerRouter);
router.addRoutes(qcrbRouter);
router.addRoutes(paymentRouter);
router.addRoutes(financeRouter);
router.addRoutes(systemRouter);
router.addRoutes(logRouter);
router.addRoutes(plantaskRouter);
router.addRoutes(offerRouter);
router.addRoutes(activityRouter);
router.addRoutes(actionGroupRouter);
router.addRoutes(reportRouter);
router.addRoutes(biRouter);
router.addRoutes(processRouter);
router.addRoutes(jpProcessRouter);
router.addRoutes(salesToolsRouter);
router.addRoutes(toolboxRouter);
router.addRoutes(specialRouter);
router.addRoutes(taskRouter);
router.addRoutes(internationalWaters);
router.addRoutes(memberRouter);
router.addRoutes(h5Router);
router.addRoutes(h5weRouter);
router.addRoutes(europeRouter);
router.addRoutes(globalRouter);

/* eslint-disable object-property-newline */
router.addRoutes([{
  path: '*', name: '404', component: {
    template: '<p>Page Not Found</p>'
  }
}]);

export default router;
